var _defs, _path, _rect, _path2, _path3, _rect2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgM1IconSimcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ccc;}.cls-1,.cls-2,.cls-3{stroke:#000;stroke-miterlimit:10;}.cls-1,.cls-3{stroke-width:3px;}.cls-2{stroke-width:5px;}.cls-2,.cls-3{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M418.98,102.57h-154.26c-3.82,0-7.49,1.52-10.19,4.22l-49.36,49.36c-2.7,2.7-4.22,6.37-4.22,10.19v351.01c0,11.08,8.99,20.07,20.07,20.07h197.96c11.08,0,20.07-8.99,20.07-20.07V122.64c0-11.08-8.99-20.07-20.07-20.07Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 233.03,
    y: 334.15,
    width: 173.94,
    height: 173.94,
    rx: 29.89,
    ry: 29.89,
    transform: "translate(741.12 101.12) rotate(90)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M269.39,509.51v-43.5c0-6.6,5.4-12,12-12h77.23c6.6,0,12,5.4,12,12v43.97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M370.61,333.2v45.2c0,6.6-5.4,12-12,12h-77.23c-6.6,0-12-5.4-12-12v-45.91"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 288.19,
    y: 390.4,
    width: 63.62,
    height: 63.62,
    transform: "translate(742.21 102.21) rotate(90)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 231.71,
    y1: 371.59,
    x2: 271.16,
    y2: 371.59
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 271.16,
    y1: 472.82,
    x2: 231.71,
    y2: 472.82
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 288.19,
    y1: 392.13,
    x2: 288.19,
    y2: 455.57
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 371.91,
    y1: 371.59,
    x2: 406.97,
    y2: 371.59
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 351.81,
    y1: 452.25,
    x2: 351.81,
    y2: 392.13
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 406.97,
    y1: 472.82,
    x2: 371.91,
    y2: 472.82
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 406.97,
    y1: 421.12,
    x2: 351.81,
    y2: 421.12
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 288.19,
    y1: 421.12,
    x2: 233.03,
    y2: 421.12
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 320,
    y1: 508.09,
    x2: 320,
    y2: 452.93
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 320,
    y1: 389.31,
    x2: 320,
    y2: 334.15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M379.39,537.43h46.59c11.08,0,20.07-8.99,20.07-20.07V122.64c0-11.08-8.99-20.07-20.07-20.07h-78.16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM1IconSimcard);
export default __webpack_public_path__ + "static/media/m1-icon-simcard.47f1db9a7a4402f7f71f0c0f86181260.svg";
export { ForwardRef as ReactComponent };